import React from 'react';
import { MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../data/contact';
export function AboutIntro() {
  return <section id="about" aria-labelledby="about-title" className="scroll-mt-20 bg-white py-20 md:py-28" data-id="element-27" data-mp="25d4axtluzz9o">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 md:px-10 lg:grid-cols-12 lg:gap-16 lg:px-[4.5rem]" data-id="element-28" data-mp="2a81s5ntalexn">
        <figure className="lg:col-span-5" data-id="element-29" data-mp="1hhjghyei658m">
          <div className="relative" data-id="element-30" data-mp="1hil2uz0yye5n">
            <img src="https://cdn.magicpatterns.com/uploads/sQ9o15GURKuisDzW2miu3X/Godfrey_IPY_UN_Oct_2007.jpg" alt="Jim Godfrey speaking as Chairman of the International Potato Center" className="aspect-[4/5] w-full rounded-3xl object-cover object-[80%_center]" data-id="element-31" data-mp="1hjmi7fp0pmt6" />
            <figcaption className="absolute bottom-5 left-5 right-5 rounded-2xl bg-cream-dark/85 px-5 py-4 backdrop-blur" data-id="element-32" data-mp="31xdagyt1g0n2">
              <p className="font-serif text-lg text-white" data-id="element-33" data-mp="36v6h1sy96wnv">Chairman, International Potato Center</p>
              <p className="mt-0.5 text-xs uppercase tracking-[0.14em] text-white/65" data-id="element-34" data-mp="2ip4qghvi4ezi">United Nations · October 2007</p>
            </figcaption>
          </div>
        </figure>

        <div className="lg:col-span-7" data-id="element-35" data-mp="28rqbkmp87y9b">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-wheat-dark" data-id="element-36" data-mp="28qp22mnuzjtp">About</p>
          <h2 id="about-title" className="mt-5 font-serif text-4xl font-bold leading-tight text-forest md:text-5xl" data-id="element-37" data-mp="23sdoq1ycur6q">
            Five decades in the boardroom. A working farmer throughout.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-charcoal" data-id="element-38" data-mp="1uz0pki9p6tc7">
            Director of R J & A E Godfrey, the family farming business in Lincolnshire, Jim has chaired and served on
            the boards of NIAB, the International Rice Research Institute (IRRI), the International Potato Center (CIP)
            and ICRISAT, was President of the Royal Agricultural Society of England, and has shaped governance across the
            CGIAR network of international research centres.
          </p>
          <p className="mt-6 text-sm font-semibold tracking-[0.14em] text-forest" data-id="element-39" data-mp="11fawe7dp2b4p">BSc, DSc, FRAgS, FIoD, FRASE</p>

          <ul className="mt-8 grid gap-3 border-t border-rule pt-8 text-[15px] text-charcoal sm:grid-cols-3" data-id="element-40" data-mp="16dm70kbtcpnz">
            <li className="flex items-center gap-2" data-id="element-41" data-mp="sia9k569wl3d">
              <MapPinIcon className="h-4 w-4 shrink-0 text-wheat" aria-hidden="true" data-id="element-42" data-mp="xftpd9imd5xf" />
              {contact.location}
            </li>
            <li data-id="element-43" data-mp="1l6z4tnkndw77">
              <a href={`mailto:${contact.email}`} className="flex items-center gap-2 break-all transition-colors duration-150 hover:text-wheat-dark" data-id="element-44" data-mp="1p66svht3huia">
                <MailIcon className="h-4 w-4 shrink-0 text-wheat" aria-hidden="true" data-id="element-45" data-mp="1bea85ytramvx" />
                {contact.email}
              </a>
            </li>
            <li data-id="element-46" data-mp="243qv4gylxbkr">
              <a href={contact.phoneHref} className="flex items-center gap-2 tabular-nums transition-colors duration-150 hover:text-wheat-dark" data-id="element-47" data-mp="2437cey14uj5o">
                <PhoneIcon className="h-4 w-4 shrink-0 text-wheat" aria-hidden="true" data-id="element-48" data-mp="28wa9vh916cr5" />
                {contact.phoneDisplay}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}